import { useCallback, useState } from 'react';
import { ListBox, Selection } from 'react-aria-components';
import { css } from '@emotion/react';
import { PuzzlePiece } from '@phosphor-icons/react';
import type { ComponentDocument } from 'common/stack/ComponentDocuments';
import { Dialog } from 'client/components/Dialog/Dialog';
import { StackAddonsDialogItem } from './StackAddonsDialogItem';
import { StackComponentsDialogDetails } from './StackComponentsDialogDetails';

export interface StackAddonsDialogProps {
  open: boolean;
  onSelect: (addon: ComponentDocument) => void;
  onClose: () => void;
}

export const StackAddonsDialog = ({ open, onSelect, onClose }: StackAddonsDialogProps) => {
  const [selectedKeys, setSelectedKeys] = useState(new Set<number | string>());

  // const template = addons.find((addon) => selectedKeys.has(addon.templateID.toString())) || null;

  const handleChange = useCallback(
    (keys: Selection) => {
      if (keys === 'all') return;
      setSelectedKeys(keys);
    },
    [setSelectedKeys]
  );

  return (
    <Dialog
      open={open}
      title="Add Add-On"
      description="Authenticate with GitHub to claim this account."
      icon={<PuzzlePiece />}
      actions={null}
      width={1000}
      onClose={onClose}
      css={dialogStyle}
    >
      <ListBox selectionMode="single" selectedKeys={selectedKeys} onSelectionChange={handleChange} css={selectStyle}>
        {/* {addons.map((item) => (
          <StackAddonsDialogItem {...item} image={'redis-logo'} />
        ))} */}
      </ListBox>
      {/* <main css={mainStyle}>{template && <StackComponentsDialogDetails template={template} />}</main> */}
    </Dialog>
  );
};

const dialogStyle = css`
  > .MuiDialog-container > .MuiPaper-root > .MuiDialogContent-root {
    display: flex;
  }
`;

const selectStyle = css`
  width: 400px;
`;

const mainStyle = css`
  flex: 1;
`;
